/**
 *  项目的配置文件
 */
const getQueryVariable = (variable) => {
     let query = window.location.search.substring(1);
     let vars = query.split("&");
     for (let i = 0; i < vars.length; i++) {
          let pair = vars[i].split("=");
          if (pair[0] == variable) {
               return pair[1];
          }
     }
     return false;
}

//确保第一时间获取到 identity值，要不然打开则undefined
const getIdentity = () => {
     if (localStorage.identity && localStorage.identity != 'false') {
          return localStorage.identity
     } else {
          if (getQueryVariable('storeId')) return 'seller'
          if (getQueryVariable('adminId')) return 'admin'
     }
}

export const apiUrl = `https://${getIdentity()}.youquanmall.com/`//接口请求地址
export const chatUrl = 'https://im.youquanmall.com/'
export const storeUrl = `https://${getIdentity()}.youquanmall.com/`//接口请求地址
export const pcUrl = 'https://www.youquanmall.com/'


export const identity = getIdentity()

export const curLang = 'zh';//当前语言,zh:中文，若为其他语言，需要对应/src/assets/language下面的文件名
export const title = 'B2B';//浏览器顶部title

/** copyright *** slodon *** version-v3.3 *** date-2022-11-18 ***主版本v3.6**/

